module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.acao === 'LISTAR') ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    class: _vm._.isNil(_vm.numeroProjeto) ? 'col-md-2' : 'col-md-3'
  }, [(_vm._.includes(_vm.itensLayoutTela, 'botaoNovo')) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.acaoOcorrencia('CRIAR', 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Ocorrência ")]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'botaoExportarExcel') && _vm.ocorrencias.length > 0) ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exportarExcel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Exportar Excel ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: _vm._.isNil(_vm.numeroProjeto) ? 'col-md-10' : 'col-md-9'
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [(_vm._.includes(_vm.itensLayoutTela, 'caixaPesquisa')) ? _c('div', {
    staticClass: "w30"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buscaTipo),
      expression: "buscaTipo"
    }],
    staticStyle: {
      "margin": "5px",
      "padding": "5px"
    },
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "value": "projeto"
    },
    domProps: {
      "checked": _vm._q(_vm.buscaTipo, "projeto")
    },
    on: {
      "change": function($event) {
        _vm.buscaTipo = "projeto"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineRadio1"
    }
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buscaTipo),
      expression: "buscaTipo"
    }],
    staticStyle: {
      "margin": "5px",
      "padding": "5px"
    },
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "entidade"
    },
    domProps: {
      "checked": _vm._q(_vm.buscaTipo, "entidade")
    },
    on: {
      "change": function($event) {
        _vm.buscaTipo = "entidade"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineRadio2"
    }
  }, [_vm._v("Nome Entidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buscaTipo),
      expression: "buscaTipo"
    }],
    staticStyle: {
      "margin": "5px",
      "padding": "5px"
    },
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "cnpj"
    },
    domProps: {
      "checked": _vm._q(_vm.buscaTipo, "cnpj")
    },
    on: {
      "change": function($event) {
        _vm.buscaTipo = "cnpj"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineRadio2"
    }
  }, [_vm._v("CNPJ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.pesquisa),
      expression: "filtro.pesquisa"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholderCampoBusca.find(function (x) { return x.tipo === _vm.buscaTipo; }).placeholder,
      "title": _vm.buscaTipo === 'projeto' ? '<h5>Informe o número do projeto</h5>' : '<h5>Informe o nome da entidade</h5>'
    },
    domProps: {
      "value": (_vm.filtro.pesquisa)
    },
    on: {
      "keyup": _vm.ajustaPesquisa,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtro, "pesquisa", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(_vm.filtro.pesquisa.length > 0) ? _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.filtro.pesquisa = '';
        _vm.ajustaPesquisa()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('div', {
    staticClass: "w30"
  }, [(_vm._.includes(_vm.itensLayoutTela, 'filtroCarteira')) ? _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.loading.carteiras) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando carteiras ...")]) : _c('span', [_c('multiselect', {
    attrs: {
      "options": _vm.listaCarteiras,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "placeholder": "Carteiras de projeto",
      "name": "carteiras_projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_vm._v(_vm._s(props.option.usu_codcart) + " - " + _vm._s(props.option.usu_nomcart))]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_vm._v(_vm._s(props.option.usu_codcart) + " - " + _vm._s(props.option.usu_nomcart))]
      }
    }], null, false, 2587724374),
    model: {
      value: (_vm.filtro.carteira),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "carteira", $$v)
      },
      expression: "filtro.carteira"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)])]) : _vm._e()])]), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'caixaPesquisa') || _vm._.includes(_vm.itensLayoutTela, 'filtroCarteira')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [(_vm._.includes(_vm.itensLayoutTela, 'filtroNivelOcorrencia')) ? _c('div', {
    staticClass: "indicadores-cb-inline",
    staticStyle: {
      "width": "50%"
    }
  }, _vm._l((_vm.listaNiveis), function(item) {
    return _c('div', {
      staticClass: "juntos"
    }, [_c('i', {
      class: _vm._.find(_vm.filtro.nivel, ['nivel', item.nivel]) ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.checkboxNivel(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: _vm._.find(_vm.filtro.nivel, ['nivel', item.nivel]) ? 'selecionado' : ''
    }, [_vm._v(" " + _vm._s(_vm.enumeradores[item.codigo]))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'filtroCodigoOcorrencia')) ? _c('div', {
    staticClass: "w30"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.loading.codigos) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando tipos de ocorrências ...")]) : _c('span', [_c('multiselect', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
    }],
    attrs: {
      "options": _vm._.orderBy(_vm._.filter(_vm.listaTiposOcorrencias, ['consultar', 1]), ['criar', 'codigo'], ['desc', 'asc']),
      "multiple": true,
      "custom-label": function (option) {
        return ("" + (option.codigo))
      },
      "track-by": "codigo",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "taggable": true,
      "title": '<h5>Códigos disponíveis para consulta<br/>Em vermelho estão os códigos <span class=\'text-red\'> impedidos de criar novas ocorrências</span></h5>',
      "placeholder": "Cód. Ocorrências",
      "name": "tipos_ocorrencias"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          class: props.option.criar === 0 ? 'text-red' : ''
        }, [_vm._v(_vm._s(props.option.codigo) + " - " + _vm._s(props.option.descricao))])]
      }
    }], null, false, 507440151),
    model: {
      value: (_vm.filtro.codigo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "codigo", $$v)
      },
      expression: "filtro.codigo"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm._.includes(_vm.itensLayoutTela, 'filtroSituacaoOcorrencia')) ? _c('div', {
    staticClass: "w20"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listaSituacoesOcorrencias,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "placeholder": "Situação",
      "name": "situacao_ocorrencias"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.enumeradores[props.option]))]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_vm._v(_vm._s(_vm.enumeradores[props.option]))])]
      }
    }], null, false, 684711505),
    model: {
      value: (_vm.filtro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "situacao", $$v)
      },
      expression: "filtro.situacao"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(!(_vm._.isEmpty(_vm.filtro.id) && _vm._.isEmpty(_vm.filtro.codigo) && _vm._.isEmpty(_vm.filtro.situacao) && _vm._.isEmpty(_vm.filtro.etapa) && _vm._.isEmpty(_vm.filtro.nivel) && _vm._.isEmpty(_vm.filtro.carteira) && _vm._.isEmpty(_vm.filtro.observacao) && _vm._.isEmpty(_vm.filtro.pesquisa))) ? _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.pesquisarOcorrencias()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pesquisar ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '2',
        size: 'large',
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'fade', distance:'2', size:'large', delay: [500, 0]}"
    }],
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "title": '<h5>Limpar os parâmetros de pesquisa</h5>'
    },
    on: {
      "click": function($event) {
        _vm.limparPesquisa();
        _vm.salvarConfiguracoes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    style: ('color: var(--cor-fraca); margin-top: ' + (_vm._.isNil(_vm.numeroProjeto) ? 35 : 5) + 'px')
  }, [(_vm.ocorrencias.length > 1) ? _c('span', [_vm._v(_vm._s(_vm.ocorrencias.length + ' ocorrências localizadas'))]) : (_vm.ocorrencias.length === 1) ? _c('span', [_vm._v(_vm._s('1 ocorrência localizada'))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {}, [(_vm.loading.tabelaOcorrencias) ? _c('div', [_vm._m(0)]) : _c('div', [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    key: 'tabelaListaOcorrencias_' + _vm.tabelaListaOcorrencias.numeroAtualizacao,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "hover": "",
      "bordered": true,
      "items": _vm.ocorrencias,
      "fields": _vm.tabelaListaOcorrencias.fields,
      "current-page": _vm.tabelaListaOcorrencias.currentPage,
      "per-page": _vm.tabelaListaOcorrencias.perPage,
      "sort-by": _vm.tabelaListaOcorrencias.sortBy,
      "sort-desc": _vm.tabelaListaOcorrencias.sortDesc,
      "empty-filtered-text": 'Não encontrei nada relacionado a ´' + _vm.pesquisa + '´ na pesquisa',
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tabelaListaOcorrencias, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tabelaListaOcorrencias, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tabelaListaOcorrencias, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tabelaListaOcorrencias, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "codigo",
      fn: function(row) {
        return [_c('div', {
          staticClass: "truncar",
          staticStyle: {
            "max-width": "250px"
          }
        }, [_vm._l(([('' + row.item.codigo).substr(0, 1)]), function(nivel) {
          return _c('span', {
            staticClass: "text-bold",
            style: ('color: var(--cor-' + (nivel === '4' ? 'atencao' : (nivel === '3' ? 'alerta' : (nivel === '2' ? 'destaque' : 'fraca'))) + ')')
          }, [_vm._v("\n                      " + _vm._s(row.item.codigo) + "\n                    ")])
        }), _vm._v("\n                  " + _vm._s(row.item.descricao) + "\n                ")], 2)]
      }
    }, {
      key: "projeto",
      fn: function(row) {
        return [(row.item.nomeProcesso === 'OCORRENCIA_ENTIDADE') ? _c('span', [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'fade',
              distance: '1',
              size: 'large',
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
          }],
          staticClass: "truncar",
          staticStyle: {
            "max-width": "250px"
          },
          attrs: {
            "title": '<h5>' + row.item.entidade + '</h5>'
          }
        }, [_c('i', [_vm._v(_vm._s(row.item.entidade))])])]) : _c('span', [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'fade',
              distance: '1',
              size: 'large',
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
          }],
          attrs: {
            "title": '<h5>' + row.item.numeroProjeto + ' - ' + row.item.projeto + '</br></br>' + row.item.entidade + '</h5>'
          }
        }, [_c('div', {
          staticClass: "truncar",
          staticStyle: {
            "max-width": "250px",
            "cursor": "pointer"
          }
        }, [_c('strong', {
          staticClass: "linkProjeto",
          on: {
            "click": function($event) {
              return _vm.abrePaginaNova('projetos/projeto/', row.item.numeroProjeto)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link"
        }), _vm._v(" " + _vm._s(row.item.numeroProjeto) + " - " + _vm._s(row.item.projeto))])]), _vm._v(" "), _c('div', {
          staticClass: "truncar",
          staticStyle: {
            "max-width": "250px"
          }
        }, [_c('i', [_vm._v(_vm._s(row.item.entidade))])])])])]
      }
    }, {
      key: "observacao",
      fn: function(row) {
        return [_c('span', {
          staticStyle: {
            "line-break": "anywhere",
            "text-align": "left"
          }
        }, [((row.value).length <= 245) ? _c('div', {
          domProps: {
            "innerHTML": _vm._s(row.value)
          }
        }) : _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'fade',
              distance: '1',
              size: 'large',
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [500, 0]}"
          }],
          attrs: {
            "title": '<h5 style=\'text-align: left\'>' + row.value + '</h5>'
          },
          domProps: {
            "innerHTML": _vm._s((row.value).length > 245 ? (row.value).substr(0, 245) + ' ...' : row.value)
          }
        })])]
      }
    }, {
      key: "etapa",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm.enumeradores[row.value]) + "\n              ")]
      }
    }, {
      key: "tarefaInicio",
      fn: function(row) {
        return [(('' + row.item.tarefaInicio).includes('00:00:00')) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'fade',
              distance: '1',
              size: 'large',
              delay: [1000, 0]
            }),
            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', delay: [1000, 0]}"
          }],
          attrs: {
            "title": '<h5>Migrado não possui hora</h5>'
          }
        }, [_vm._v(_vm._s(_vm._f("moment")(row.item.tarefaInicio, "DD/MM/YYYY")))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.item.tarefaInicio, "DD/MM/YYYY HH:mm")))])]
      }
    }, {
      key: "acoes",
      fn: function(row) {
        return [(!_vm._.includes(['CANCELADO', 'BAIXADO'], row.item.etapa)) ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.acaoOcorrencia('EDITAR', row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['CANCELADO', 'BAIXADO'], row.item.etapa)) ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.acaoOcorrencia('VISUALIZAR', row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar")]) : _vm._e()]
      }
    }], null, false, 933782560)
  }), _vm._v(" "), (!_vm._.isEmpty(_vm.ocorrencias) && _vm.ocorrencias.length > _vm.tabelaListaOcorrencias.perPage && _vm.tabelaListaOcorrencias.totalRows > _vm.tabelaListaOcorrencias.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.tabelaListaOcorrencias.totalRows,
      "per-page": _vm.tabelaListaOcorrencias.perPage
    },
    model: {
      value: (_vm.tabelaListaOcorrencias.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tabelaListaOcorrencias, "currentPage", $$v)
      },
      expression: "tabelaListaOcorrencias.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.acao !== 'LISTAR') ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: (_vm._.includes(_vm.itensLayoutTela, 'formatacaoCaixa') ? 'box' : '') + ' box-widget'
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('span', [(_vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO' || !_vm._.isNil(_vm.numeroProjeto)) ? _c('div', {
    staticClass: "text-bold col-md-2",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.ocorrencia.tipo))]) : _c('div', {
    staticClass: "col-md-2 form-control-static",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.tipo),
      expression: "ocorrencia.tipo"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoOcorrencia",
      "id": "tipoOcorrenciaProjeto"
    },
    domProps: {
      "value": 'PROJETO',
      "checked": _vm._q(_vm.ocorrencia.tipo, 'PROJETO')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "tipo", 'PROJETO')
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tipoOcorrenciaProjeto"
    }
  }, [_vm._v("Projeto")])]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.tipo),
      expression: "ocorrencia.tipo"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoOcorrencia",
      "id": "tipoOcorrenciaEntidade"
    },
    domProps: {
      "value": 'ENTIDADE',
      "checked": _vm._q(_vm.ocorrencia.tipo, 'ENTIDADE')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "tipo", 'ENTIDADE')
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tipoOcorrenciaEntidade"
    }
  }, [_vm._v("Entidade")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(_vm.loading.listaProjetosEntidades) ? _c('div', [_vm._m(1)]) : _c('div', {
    ref: 'projeto_entidade_' + _vm.numeroAtualizacao
  }, [(_vm.ocorrencia.tipo === 'PROJETO') ? _c('span', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaProjetosEntidades['projetos'],
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO' || !_vm._.isNil(_vm.numeroProjeto),
      "custom-label": function (option) {
        return ("" + (option.ds_codigo_projeto_erp + option.sitprj + option.ds_nome))
      },
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "placeholder": "Selecione um projeto",
      "name": "projeto_entidade"
    },
    on: {
      "select": function($event) {
        return _vm.alteraListaTiposOcorrencias($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" (" + _vm._s(props.option.sitprj) + ") " + _vm._s(props.option.ds_nome))])]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" "), _c('span', {
          staticClass: "identificadorIDProjeto text-muted"
        }, [_vm._v(_vm._s(props.option.sitprj))]), _vm._v(" " + _vm._s(props.option.ds_nome))])]
      }
    }], null, false, 2886987170),
    model: {
      value: (_vm.ocorrencia.alvo),
      callback: function($$v) {
        _vm.$set(_vm.ocorrencia, "alvo", $$v)
      },
      expression: "ocorrencia.alvo"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('projeto_entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar um projeto na lista")]) : _vm._e()], 1) : _c('span', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaProjetosEntidades['entidades'],
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
      "custom-label": function (option) {
        return ("" + (option.ds_cnpj + option.ds_nome))
      },
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "placeholder": "Selecione uma entidade",
      "name": "projeto_entidade"
    },
    on: {
      "select": function($event) {
        return _vm.alteraListaTiposOcorrencias($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(_vm._f("cnpj")(props.option.ds_cnpj)))]), _vm._v(" " + _vm._s(props.option.ds_nome))])]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(_vm._f("cnpj")(props.option.ds_cnpj)))]), _vm._v(" " + _vm._s(props.option.ds_nome))])]
      }
    }], null, false, 926782840),
    model: {
      value: (_vm.ocorrencia.alvo),
      callback: function($$v) {
        _vm.$set(_vm.ocorrencia, "alvo", $$v)
      },
      expression: "ocorrencia.alvo"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('projeto_entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar uma entidade na lista")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('codigo_ocorrencia') || _vm.errors.first('grupo_ocorrencia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.loading.listaOcorrencias) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando lista de ocorrências...")]) : _c('span', [_c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grupoOcorrencia),
      expression: "grupoOcorrencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
      "name": "grupo_ocorrencia"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grupoOcorrencia = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.ocorrencia.enquadramento = null
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Informativa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Alerta")]), _vm._v(" "), (_vm.ocorrencia.tipo === 'PROJETO') ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Restritiva Relativa")]) : _vm._e(), _vm._v(" "), (_vm.ocorrencia.tipo === 'ENTIDADE') ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Restritiva Absoluta")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('grupo_ocorrencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Selecione qual o grupo de ocorrências deseja")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(!_vm._.isNull(_vm.grupoOcorrencia)) ? _c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm._.orderBy(_vm._.filter(_vm.listaTiposOcorrencias, {
        'tipo_ocorrencia': _vm._.toNumber(_vm.grupoOcorrencia),
        'criar': 1,
        'automatico': 0
      }), ['codigo', 'ASC']),
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
      "multiple": false,
      "placeholder": "Selecione uma ocorrência",
      "label": "descricao",
      "track-by": "codigo",
      "custom-label": function (option) {
        return ("" + (option.codigo + option.descricao))
      },
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "codigo_ocorrencia"
    },
    on: {
      "select": function($event) {
        _vm.ocorrencia.prazo = null
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao) + "\n                          ")]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao))])]
      }
    }], null, false, 484598346),
    model: {
      value: (_vm.ocorrencia.enquadramento),
      callback: function($$v) {
        _vm.$set(_vm.ocorrencia, "enquadramento", $$v)
      },
      expression: "ocorrencia.enquadramento"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2) : _vm._e(), _vm._v(" "), (_vm.errors.first('codigo_ocorrencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar o código da ocorrência desejada na lista")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('observacao_ocorrencia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_ocorrencia",
      "id": "observacao_ocorrencia",
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'SOLICITACAO',
      "placeholder": !_vm._.isEmpty(_vm._.get(_vm.ocorrencia.enquadramento, 'informacao', '')) ? _vm.ocorrencia.enquadramento.informacao : 'Informe o detalhamento da situação que gerou a ocorrência'
    },
    model: {
      value: (_vm.ocorrencia.observacao),
      callback: function($$v) {
        _vm.$set(_vm.ocorrencia, "observacao", $$v)
      },
      expression: "ocorrencia.observacao"
    }
  }), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacao) && _vm.ocorrencia.observacao.length > 245 && _vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Atenção! O SGP guardará essa observação com " + _vm._s(_vm.ocorrencia.observacao.length) + " caracteres, mas no Sapiens só os 245 primeiros caracteres serão gravados")]) : _vm._e(), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacao) && _vm.ocorrencia.observacao.length > 1000 && _vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Atenção! O texto esta muito grande, indicamos que o resuma")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('observacao_ocorrencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Informe o quê se refere essa ocorrência")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm._.includes([2200, 2201, 2202, 2203], _vm._.get(_vm.ocorrencia, 'enquadramento.codigo', 0))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('prazo_ocorrencia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Prazo para baixa:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "prazo_ocorrencia",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehVisualizacao || !_vm._.includes(['SOLICITACAO', 'AGUARDA_APROVACAO'], _vm.etapa) || (_vm._.includes(['AGUARDA_APROVACAO'], _vm.etapa) && !_vm.ehGestor),
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy",
      "disabled-dates": {
        to: new Date(_vm.hoje.getTime() - 86400000),
        from: new Date(_vm.hoje.getTime() + 432000000)
      }
    },
    model: {
      value: (_vm.ocorrencia.prazo),
      callback: function($$v) {
        _vm.$set(_vm.ocorrencia, "prazo", $$v)
      },
      expression: "ocorrencia.prazo"
    }
  }), _vm._v(" "), (_vm.errors.first('prazo_ocorrencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O prazo é obrigatório para ocorrência " + _vm._s(_vm._.get(_vm.ocorrencia, 'enquadramento.codigo')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Anexos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.ocorrencia.anexos,
      "documentTypes": '',
      "disable": _vm.ehVisualizacao || (_vm.etapa !== 'SOLICITACAO' && _vm.ocorrencia.acao !== 'ASSENTAMENTO')
    }
  })], 1)])]), _vm._v(" "), (!_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Histórico:"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.layoutHistorico = _vm.layoutHistorico === 'RESUMIDO' ? 'COMPLETO' : 'RESUMIDO'
      }
    }
  }, [_vm._v("Mostrando " + _vm._s(_vm._.toLower(_vm.layoutHistorico)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped table-hover"
  }, [_vm._m(2), _vm._v(" "), (_vm._.has(_vm.itemOcorrencia, 'historico') && !_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('tbody', _vm._l((_vm.itemOcorrencia.historico), function(item) {
    return (_vm.layoutHistorico === 'COMPLETO' || (_vm.layoutHistorico === 'RESUMIDO' && !_vm._.includes(['CRIACAO_OCORRENCIA_SAPIENS', 'ATUALIZACAO_OCORRENCIA_SAPIENS', 'MIGRADO_MODULO_ACOMPANHAMENTO', 'AGUARDA_APROVACAO', 'AGUARDA_BAIXA', 'ENCAMINHAR_APROVACAO', 'BAIXAR', 'APROVAR'], item.nome))) ? _c('tr', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.enumeradores[item.nome] + (item.nome === 'ASSENTAMENTO' ? ' nº ' + (_vm._.findIndex(_vm._.filter(_vm.itemOcorrencia.historico, ['nome', 'ASSENTAMENTO']), item) + 1) : '')))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "truncar",
      staticStyle: {
        "width": "90%"
      }
    }, [_vm._v(_vm._s(item.ds_nome_usuario))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(_vm._.isNull(item.termino) ? item.inicio : item.termino, "DD/MM/YYYY HH:mm")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [(!_vm._.isNil(item.observacao)) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.observacao)
      }
    }) : _vm._e()])]) : _vm._e()
  }), 0) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm._.includes(['VISUALIZAR', 'CRIAR'], _vm.acao) && !_vm.ehVisualizacao && !_vm._.includes(['CANCELADO', 'BAIXADO'], _vm.etapa)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Decisão:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "ASSENTAMENTO",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "ASSENTAMENTO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "ASSENTAMENTO")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['ASSENTAMENTO']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.etapa === 'LIBERADO') ? _c('div', [((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "ENCAMINHAR_BAIXA",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "ENCAMINHAR_BAIXA")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "ENCAMINHAR_BAIXA")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['ENCAMINHAR_BAIXA']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e(), _vm._v(" "), ((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && !_vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo))) ? _c('div', [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "BAIXAR",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "BAIXAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "BAIXAR")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['BAIXAR']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e(), _vm._v(" "), (('' + _vm.ocorrencia.enquadramento.codigo)[0] === '1' || (('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && !_vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo))) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "CANCELAR",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "CANCELAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "CANCELAR")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['CANCELAR']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.etapa === 'AGUARDA_APROVACAO' && _vm.ehGestor) ? _c('div', [((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "APROVAR",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "APROVAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "APROVAR")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['APROVAR']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e(), _vm._v(" "), ((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "CANCELAR",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "CANCELAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "CANCELAR")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['CANCELAR']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.etapa === 'AGUARDA_BAIXA' && _vm.ehGestor) ? _c('div', [((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "BAIXAR",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "BAIXAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "BAIXAR")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['BAIXAR']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e(), _vm._v(" "), ((('' + _vm.ocorrencia.enquadramento.codigo)[0] === '2' && _vm._.includes([2200, 2201, 2202, 2203], _vm.ocorrencia.enquadramento.codigo)) || _vm._.includes(['3', '4'], ('' + _vm.ocorrencia.enquadramento.codigo)[0])) ? _c('div', [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrencia.acao),
      expression: "ocorrencia.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "CANCELAR",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.ocorrencia.acao, "CANCELAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrencia, "acao", "CANCELAR")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.enumeradores['CANCELAR']) + " "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.enumeradores[_vm.ocorrencia.acao]) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: 'col-md-12' + (_vm._.includes(['CANCELAR', 'ASSENTAMENTO'], _vm.ocorrencia.acao) ? ' required-field ' : ' ') + (_vm.errors.first('observacao_decisao') ? ' has-error ' : '')
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao_decisao"
    }
  }, [_vm._v("Observação para " + _vm._s(_vm.enumeradores[_vm.ocorrencia.acao]) + ":")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm._.includes(['CANCELAR', 'ASSENTAMENTO'], _vm.ocorrencia.acao) ? 'required' : ''),
      expression: "_.includes(['CANCELAR', 'ASSENTAMENTO'], ocorrencia.acao) ? 'required' : ''"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": (_vm._.includes(['CANCELAR', 'ASSENTAMENTO'], _vm.ocorrencia.acao) ? 'Informe' : 'Opcionalmente pode informar') + ' o motivo para ' + _vm._.toLower(_vm.enumeradores[_vm.ocorrencia.acao]) + ' esta ocorrência',
      "disabled": _vm.ehVisualizacao,
      "name": "observacao_decisao",
      "id": "observacao_decisao"
    },
    model: {
      value: (_vm.ocorrencia.observacaoDecisao),
      callback: function($$v) {
        _vm.$set(_vm.ocorrencia, "observacaoDecisao", $$v)
      },
      expression: "ocorrencia.observacaoDecisao"
    }
  }), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacaoDecisao) && _vm.ocorrencia.observacaoDecisao.length > 245) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Atenção! O SGP guardará esse motivo com " + _vm._s(_vm.ocorrencia.observacaoDecisao.length) + " caracteres, mas no Sapiens só os 245 primeiros caracteres serão gravados")]) : _vm._e(), _vm._v(" "), (!_vm._.isNil(_vm.ocorrencia.observacaoDecisao) && _vm.ocorrencia.observacaoDecisao.length > 1000) ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Atenção! O texto esta muito grande, indicamos que o resuma")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('observacao_decisao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Ao " + _vm._s(_vm.enumeradores[_vm.ocorrencia.acao]) + " é obrigatório informar um motivo para constar na observação da tarefa")]) : _vm._e()], 1)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-md-offset-2"
  }, [(_vm.ehGestor || _vm._.includes(['SOLICITACAO', 'LIBERADO'], _vm.etapa) || _vm.ocorrencia.acao === 'ASSENTAMENTO') ? _c('span', [(_vm.acao !== 'VISUALIZAR') ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.validaConclusao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.botaoVoltar) ? _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1) : _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.acaoOcorrencia('LISTAR', null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Volta para lista")])], 1)]), _vm._v(" "), (!_vm._.isNull(_vm.id) && !_vm.loading.tela && !_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.etapa)) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "col-md-3 text-right"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Ocorrência Ativa afeta o projeto/entidade. Inativa não afeta, pois foi baixada, cancelada ou ainda aguarda aprovação</h5>'
    }
  }, [(_vm.enumeradores[_vm.ativo] === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Ativo")]) : _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("Inativo")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Mostra a situação do processo <span class=\'realce\'>' + _vm.id + '</span> ligada a ocorrência. Em geral ficará em execução até ser baixada (passa para feito) ou cancelada</h5>'
    }
  }, [(_vm._.includes(['FEITO', 'CANCELADO'], _vm.itemOcorrencia.situacao)) ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("Processo " + _vm._s(_vm.enumeradores[_vm.itemOcorrencia.situacao]))]) : _c('span', {
    staticClass: "label label-primary",
    staticStyle: {
      "background": "var(--cor-alerta-light) !important"
    }
  }, [_vm._v("Processo " + _vm._s(_vm.enumeradores[_vm.itemOcorrencia.situacao]))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Mostra a etapa atual/situação em que se encontra a ocorrência. Poder Liberada, Aguardando aprovção ou baixa, baixada ou cancelada</h5>'
    }
  }, [(_vm._.includes(['BAIXADO', 'CANCELADO'], _vm.etapa)) ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(_vm.enumeradores[_vm.etapa]))]) : _c('span', {
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.enumeradores[_vm.etapa]))])])]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando tabela ...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando lista de projetos e entidades...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px",
      "text-align": "center"
    }
  }, [_vm._v("Etapa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "text-align": "center"
    }
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "120px",
      "text-align": "center"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Observação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa770a48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/ocorrencias/EditaOcorrencias.vue
// module id = 2028
// module chunks = 2